export const FEEDBACK_TYPE_OPTIONS = [
  { value: "Suggestion", label: "Suggestion" },
  { value: "Complaint", label: "Complaint" },
  { value: "Appreciation", label: "Appreciation" },
  { value: "Other", label: "Other" },
] as const;

export const FEEDBACK_STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "published", label: "Published" },
] as const;

export type FeedbackType = (typeof FEEDBACK_TYPE_OPTIONS)[number]["value"];
export type FeedbackStatus = (typeof FEEDBACK_STATUS_OPTIONS)[number]["value"];

export interface FeedbackPayload {
  full_name: string;
  mobile?: string;
  email?: string;
  feedback_type: FeedbackType;
  rating: number;
  message: string;
}

export interface FeedbackAdminPayload extends FeedbackPayload {
  status?: FeedbackStatus;
  admin_reply?: string;
  is_enabled?: boolean;
  order_by?: number;
}

export interface FeedbackRecord extends FeedbackAdminPayload {
  id: number;
  admin_reply?: string | null;
  created_at?: string;
  updated_at?: string;
}

export function formatFeedbackStatusLabel(status?: string | null): string {
  const hit = FEEDBACK_STATUS_OPTIONS.find(o => o.value === status);
  return hit?.label ?? (status ? status.replace(/_/g, " ") : "—");
}

export function feedbackStatusClass(status?: string | null): string {
  switch ((status ?? "").toLowerCase()) {
    case "pending":
      return "bg-blue-500/15 text-blue-700 hover:bg-blue-500/15";
    case "published":
      return "bg-emerald-500/15 text-emerald-700 hover:bg-emerald-500/15";
    default:
      return "bg-muted text-muted-foreground hover:bg-muted";
  }
}
